let _cached: string = '';

export function getBrowserTimezone(): string {
  if (_cached) return _cached;
  try {
    _cached = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    _cached = 'UTC';
  }
  return _cached;
}
